import { httpClient } from '@/shared/api/httpClient'

import type {
  UpdatePreferencesPayload,
  UpdateProfilePayload,
  UserProfile,
  UserStats,
} from '../types/profile.types'

export const profileApi = {
  get: (): Promise<UserProfile> => httpClient.get<UserProfile>('/me/profile').then((r) => r.data),

  update: (payload: UpdateProfilePayload): Promise<UserProfile> => {
    // Strip campos internos del optimistic update — el backend no los entiende.
    const { _favoriteGamesOptimistic: _opt, ...body } = payload
    return httpClient.patch<UserProfile>('/me/profile', body).then((r) => r.data)
  },

  changePassword: (currentPassword: string, newPassword: string): Promise<void> =>
    httpClient.post('/me/profile/password', { currentPassword, newPassword }).then(() => undefined),

  /**
   * Baja self-service: borra permanentemente la cuenta (confirmada por
   * contraseña). Tras el 204, el caller debe limpiar la sesión local y
   * redirigir (los refresh tokens ya se han revocado en el server).
   */
  deleteAccount: (password: string): Promise<void> =>
    httpClient.post('/me/deletion', { password }).then(() => undefined),

  getStats: (): Promise<UserStats> =>
    httpClient.get<UserStats>('/me/profile/stats').then((r) => r.data),

  /** Oculta el onboarding para siempre (completado o descartado). Idempotente. */
  dismissOnboarding: (): Promise<void> =>
    httpClient.post('/me/onboarding/dismiss').then(() => undefined),

  /**
   * Actualiza preferencias de notificación. El backend devuelve el
   * {@link UserProfile} completo para que el cache TanStack se refresque
   * de golpe — mismo patrón que {@code update}.
   */
  updatePreferences: (payload: UpdatePreferencesPayload): Promise<UserProfile> =>
    httpClient.patch<UserProfile>('/me/preferences', payload).then((r) => r.data),
}
